// extracted by mini-css-extract-plugin
module.exports = {"card":"_16219","icon":"_12880","title":"_4203","message":"_15242","button":"_17029"};